import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const getDefaultState = () => {
  return { startedAt: null }
}

const state = getDefaultState()

const getters = {}

const mutations = {
  setStartedAt(state, payload) {
    state.startedAt = payload
  },
  resetState(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118)
    Object.assign(state, getDefaultState())
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}